
import Vue from "vue";

export default Vue.extend({
  name: "CopyToClipboard",
  props: {
    text: {
      type: String,
    },
  },
  data() {
    return {
      copied: false,
    };
  },
  methods: {
    async copyToClipboard() {
      await navigator.clipboard.writeText(this.text);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 3000);
    },
  },
});
